import Bing from './MapProvider/Bing'
import GMaps from './MapProvider/GMaps'
import OSM from './MapProvider/OSM'
import BANOC from './MapProvider/BANOC'

export default class LocationService {
    static GOOGLE = 'maps'
    static OSM = 'osm'
    static BING = 'bing'
    static BANOC = 'banoc'

    constructor(config, company_id) {
        this.country = null
        this.city = null
        let mapProvider = config.mapProvider ? config.mapProvider : config

        var country = config.restriction
            ? config.restriction.country
            : process.env.VUE_APP_MAP_COUNTRY_RESTRICTION
        var city = config.restriction
            ? config.restriction.city
            : process.env.VUE_APP_MAP_CITY_RESTRICTION

        if (country && country.length > 0) {
            this.country = country
        }
        if (city && city.length > 0) {
            this.city = city
        }
        switch (mapProvider) {
            case LocationService.BING: {
                const BING_KEY = process.env.VUE_APP_BING_KEY
                this.map = new Bing(
                    BING_KEY,
                    this.country,
                    this.city,
                    company_id
                )
                break
            }

            case LocationService.OSM:
                this.map = new OSM(this.country)
                break

            case LocationService.GOOGLE: {
                const MAPS_KEY = process.env.VUE_APP_GOOGLE_MAPS_KEY
                this.map = new GMaps(MAPS_KEY, this.country, this.city)
                break
            }

            case LocationService.BANOC:
                this.map = new BANOC()
                break

            default:
                break
        }
    }

    search(locationName) {
        return new Promise((resolve, reject) => {
            this.map
                .search(locationName)
                .then((response) => {
                    const results = this.map.handle(response.data) || []
                    const cityRestricted = (
                        this.map.restrictedCity || ''
                    ).toLowerCase()
                    const supportsCityRetry =
                        typeof this.map.searchCity === 'function'

                    // Without a provider-side narrowing endpoint (OSM, Google
                    // REST), there's nothing more to try — return what we got
                    // and let LocationField apply the country/city restriction
                    // post-hoc.
                    if (!supportsCityRetry || !cityRestricted) {
                        if (results.length > 0) return resolve(results)
                        return reject(
                            this.map.errors && this.map.errors.length
                                ? this.map.errors
                                : ['error.search.noData']
                        )
                    }

                    // Bing path: check the first hit's locality and ask the
                    // narrower endpoint if it doesn't match.
                    const sets = response.data.resourceSets || []
                    const firstResource =
                        ((sets[0] || {}).resources || [])[0] || {}
                    const firstCity = (
                        ((firstResource.address || {}).locality || '')
                    ).toLowerCase()

                    if (firstCity === cityRestricted) {
                        return results.length > 0
                            ? resolve(results)
                            : reject(this.map.errors)
                    }

                    this.map
                        .searchCity(locationName)
                        .then((responseCity) => {
                            const cityResources =
                                (((responseCity.data || {}).response || {})
                                    .resourceSets || [])[0] &&
                                (((responseCity.data || {}).response || {})
                                    .resourceSets || [])[0].resources
                                    ? (((responseCity.data || {}).response || {}).resourceSets)[0].resources
                                    : []
                            cityResources.forEach((r) =>
                                sets[0].resources.push(r)
                            )
                            const merged = this.map.handle(response.data)
                            if (!merged || merged.length === 0) {
                                return reject(this.map.errors)
                            }
                            merged.sort((a, b) => {
                                const aHit = a.address
                                    .toLowerCase()
                                    .includes(cityRestricted)
                                const bHit = b.address
                                    .toLowerCase()
                                    .includes(cityRestricted)
                                if (aHit === bHit) return 0
                                return aHit ? -1 : 1
                            })
                            resolve(merged)
                        })
                        .catch(reject)
                })
                .catch(reject)
        })
    }

    reverseSearch(coordinates) {
        return new Promise((resolve, reject) => {
            this.map
                .reverseSearch(coordinates)
                .then((response) => {
                    const formattedAddress = this.map.reverseHandle(
                        response.data
                    )
                    if (formattedAddress && formattedAddress.length > 0) {
                        return resolve(formattedAddress)
                    }
                    reject(
                        this.map.errors && this.map.errors.length
                            ? this.map.errors
                            : ['error.search.noData']
                    )
                })
                .catch((e) => reject(e))
        })
    }
}
